// extracted by mini-css-extract-plugin
module.exports = {"launchWrapper":"style_launchWrapper__O0kan"};